import { Container } from "@/components/container";
import {
  Toolbar,
  ToolbarActions,
  ToolbarDescription,
  ToolbarHeading,
  ToolbarPageTitle,
} from "@/partials/toolbar";
import { KeenIcon } from "@/components";
import { useNavigate } from "react-router-dom";
import ThemeRouteApprovalsTable from "./ThemeRouteApprovalsTable";

const ThemeRouteApprovalsPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <Container>
        <Toolbar>
          <ToolbarHeading>
            <ToolbarPageTitle text="Theme Route Approval Requests" />
            <ToolbarDescription>
              Review and approve or reject theme route publication requests.
            </ToolbarDescription>
          </ToolbarHeading>
          <ToolbarActions>
            <button
              type="button"
              className="btn btn-sm btn-light flex items-center gap-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              onClick={() => navigate("/theme-routes")}
              aria-label="Back to theme routes"
            >
              <KeenIcon
                type="filled"
                icon="arrow-left"
                className="text-gray-500"
              />
              Back to Theme Routes
            </button>
          </ToolbarActions>
        </Toolbar>
      </Container>

      <Container>
        <ThemeRouteApprovalsTable />
      </Container>
    </>
  );
};

export default ThemeRouteApprovalsPage;
